import {NgForOf} from "@angular/common";
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FlexModule} from "@angular/flex-layout";
import {MatChip, MatChipSet} from "@angular/material/chips";
import {MatIcon} from "@angular/material/icon";
import {MatTabLabel} from "@angular/material/tabs";
import {BookingConfig, Space} from "../bookings.model";
import {LeaseBookingsService} from "../lease-bookings.service";
import {SelectableCategory} from "@features/settings/industries/industry.model";
import {AppSharedModule} from "@modules/app-shared.module";
import {PanelType} from "@shared-components/info-panel/info-panel.component";
import {DateUtilsService} from "@shared-services/dateUtils.service";
import {displayStatus} from "@ui-kit/framework/util/static/string-format-util";

@Component({
  selector: 'app-space-selection-list',
  standalone: true,
  imports: [
    AppSharedModule,
    FlexModule,
    MatChip,
    MatChipSet,
    MatIcon,
    NgForOf,
    MatTabLabel
  ],
  templateUrl: './space-selection-list.component.html',
  styleUrl: './space-selection-list.component.scss'
})
export class SpaceSelectionListComponent {
  @Input() availableSpaces: {
    fullyAvailable: Space[],
    partiallyAvailable: Space[]
  } = {fullyAvailable: [], partiallyAvailable: []};
  @Input() selectedSpaces: string[] = [];
  @Input() bookingConfig: BookingConfig = new BookingConfig();
  @Input() allIndustries: SelectableCategory[] = [];
  @Input() listHeight: string = '530px';
  @Input() warnOnUnavailableSelection: boolean = true;

  @Output() onSelectSpace = new EventEmitter<string>();

  constructor(private bookingsService: LeaseBookingsService,
              public dateUtils: DateUtilsService) {
  }

  isSpaceSelected(spaceId: string) {
    return this.selectedSpaces.includes(spaceId);
  }

  hasPricing(space: Space) {
    const pricing = this.bookingsService.getSpacePricingString(space, this.bookingConfig.patternType);
    return pricing != null && pricing.length > 0;
  }

  getSpacePricing(space: Space) {
    return this.bookingsService.getSpacePricingString(space, this.bookingConfig.patternType);
  }

  getMonthlyPricing(space: Space): number | null {
    return this.bookingsService.getMonthlyPricing(space, this.bookingConfig.patternType);
  }

  displayIndustry(code: string): string {
    const category = this.allIndustries.find(cat => cat.code == code);
    if (category) return category.labelNameOverride ?? category.name;
    return '';
  }

  get unavailableSpaceSelected() {
    return this.selectedSpaces.length > 0 && this.selectedSpaces.some(f => this.availableSpaces.partiallyAvailable.map(m => m.id).includes(f));
  }

  protected readonly PanelType = PanelType;
  protected readonly displayStatus = displayStatus;
}
